import { PvCheckbox } from 'components/form/PvCheckbox';
import { PvSelect } from 'components/form/PvSelect';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { Flex, Label } from 'rebass';
import { reduxForm } from 'redux-form';
import styled from 'styled-components';
import { space, width } from 'styled-system';
import { PvBox, PvButton, PvInput } from 'styles/CustomComponents';
import {
  examClassesToDropdown,
  lessonTypes,
  getLabel,
  lessonHasExamClass,
} from "../../util/SearchUtil";

const PvSearchBtn = styled(PvButton)`
  ${space}
  ${width}
`;

const lessonsToDropdown = (lessons, examClass, lessonType) => {
  if (!lessons) {
    return [];
  }
  if (examClass) {
    lessons = lessons.filter(lesson => lessonHasExamClass(lesson, examClass));
  }
  if (lessonType) {
    lessons = lessons.filter(lesson => lesson.lessonType === lessonType);
  }

  return lessons
    .map(l => {
      return { value: l.lessonId, label: l.description };
  }).sort((a, b) => {
    const nameA = a.label.toUpperCase(); // ignore upper and lowercase
    const nameB = b.label.toUpperCase(); // ignore upper and lowercase
    return nameA.localeCompare(nameB);
  });
};

const lessonSelected = (lessonId, lessons) => {
  return {value: lessonId, label: getLabel(lessonId, lessonsToDropdown(lessons))};
};

const termSet = (term) => {
  return (term && term.length > 0 && !Array.isArray(term)) || (Array.isArray(term) && term.some((e) => termSet(e)));
};

const searchDisabled = (searchTerms) => {

  let givenTerms = Object.values(searchTerms).filter((e) => (termSet(e)));
  return givenTerms.length <= 0;
};

const paddingLeft = {
  paddingLeft: '5px'
};


class LessonStatusSearch extends Component {
  validateAndUpdateSearchTerms(terms) {
    if (terms.examClass || terms.lessonType) {
      terms.lessonIds = null;
      terms.searchMissingLessons = false;
    }
    if (terms.lessonType) {
      terms.examClass = null;
      terms.lessonIds = null;
      terms.searchMissingLessons = false;
    }
    this.props.updateSearchTerms(terms);
  };

  render() {
    const {
      lessons,
      searchFn,
      searchTerms,
      examClasses,
      loading
    } = this.props;

    return (
      <PvBox my={3}>
        <form>
          <Flex flexWrap='wrap'>
            <PvBox mb={[0, 0, 3]} w={[1, 1, 1]}>
              <PvBox display='inline-block' px={2} w={[1 / 2, 1 / 2, 1 / 8]}>
                <Label mb={2}>
                  <Translate value='search.lesson_type' />
                </Label>
                <PvSelect
                  placeholder=''
                  name='lessonType'
                  options={lessonTypes()}
                  value={{
                    value: this.props.searchTerms.lessonType,
                    label: getLabel(this.props.searchTerms.lessonType, lessonTypes())
                  }}
                  onChange={(option) => this.validateAndUpdateSearchTerms({lessonType: option.value})}
                  addEmpty={true}
                />
              </PvBox>
              <PvBox minWidth='8em' display='inline-block' px={2} pb={3} w={[1 / 3, 1 / 3, 2 / 8]}>
                <Label mb={2}>
                  <Translate value='search.exam_class' />
                </Label>
                <PvSelect
                  placeholder=''
                  options={examClassesToDropdown(examClasses)}
                  value={{value: searchTerms.examClass, label: searchTerms.examClass}}
                  onChange={(option) => this.validateAndUpdateSearchTerms({examClass: option.value})}
                  isLoading={loading}
                  addEmpty={true}
                />
              </PvBox>
              <PvBox display='inline-block' px={2} w={[1, 1 / 2, 1 / 3]} mb={3}>
                <Label mb={2}>
                  <Translate value='search.missing_lesson' />
                </Label>
                <PvSelect
                  isLoading={loading}
                  placeholder={<Translate value='search.select_missing_lesson' />}
                  name='missingLesson'
                  options={lessonsToDropdown(lessons, searchTerms.examClass, searchTerms.lessonType)}
                  value={lessonSelected((!!this.props.searchTerms.lessonIds && this.props.searchTerms.lessonIds.length > 0) ? this.props.searchTerms.lessonIds[0] : '', lessons)}
                  onChange={(option) => this.validateAndUpdateSearchTerms({
                    lessonIds: [option.value],
                    searchMissingLessons: (!!option.value && option.value.length > 0) ? true : false
                  })}
                  addEmpty={true}
                />
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} w={[1, 1 / 2, 1 / 4]}>
                <Label mb={2}>
                  <PvCheckbox type="checkbox" defaultChecked={searchTerms.applicantLessonStatus === 'UNDONE'}
                              onChange={(e) => {
                                this.validateAndUpdateSearchTerms({applicantLessonStatus: e.target.checked ? 'UNDONE' : null});
                              }}
                  />
                  <Translate value='search.show_only_undone' style={paddingLeft} />
                </Label>
              </PvBox>
            </PvBox>


            <PvBox w={[1, 1, 1]}>
              <PvBox display='inline-block' px={2} w={[1 / 3, 1 / 3, 1 / 8]} mb={3}>
                <Label mb={2}>
                  <Translate value='search.course_number' />
                </Label>
                <PvInput
                  py={3}
                  name="courseNumber"
                  value={this.props.searchTerms.courseNumber}
                  onChange={(e) =>
                    this.validateAndUpdateSearchTerms({
                      courseNumber: e.target.value,
                    })
                  }
                />
              </PvBox>
              <PvBox display='inline-block' px={2} w={[1 / 3, 1 / 3, 1 / 8]}>
                <Label mb={2}>
                  <Translate value='search.course_year' />
                </Label>
                <PvInput
                  name="courseYear"
                  value={this.props.searchTerms.courseYear}
                  onChange={(e) =>
                    this.validateAndUpdateSearchTerms({
                      courseYear: e.target.value,
                    })
                  }
                />
              </PvBox>
              <PvBox display='inline-block' px={2} w={[1 / 3, 1 / 3, 1 / 8]}>
                <Label mb={2}>
                  <Translate value='search.course_unit' />
                </Label>
                <PvInput
                  name="courseUnit"
                  value={this.props.searchTerms.courseUnit}
                  onChange={(e) =>
                    this.validateAndUpdateSearchTerms({
                      courseUnit: e.target.value,
                    })
                  }
                />
              </PvBox>
              <PvBox display='inline-block' px={2} w={[3 / 4, 1 / 2, 3 / 8]}>
                <Label mb={2}>
                  <Translate value='search.applicant_name' />
                </Label>
                <PvInput name='applicantName'
                         onChange={(e) => this.validateAndUpdateSearchTerms({applicantName: e.target.value})}
                         value={this.props.searchTerms.applicantName}
                />
              </PvBox>
              <PvBox display='inline-block' px={2} w={[1 / 4, 2 / 8, 1 / 8]}>
                <PvSearchBtn px={3} width='100%'
                             disabled={searchDisabled(searchTerms)}
                             onClick={(e) => {
                               e.preventDefault();
                               searchFn(searchTerms);
                             }}>
                  <Translate value='action.search' />
                </PvSearchBtn>
              </PvBox>
            </PvBox>
          </Flex>
        </form>
      </PvBox>
    );
  }
}

LessonStatusSearch.propTypes = {
  lessons: PropTypes.array,
  route: PropTypes.object,
  loading: PropTypes.bool,
  searchFn: PropTypes.func,
  searchTerms: PropTypes.object,
  examClasses: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    route: state.routing.location,
    lessons: state.general.lessons,
    loading: state.general.loading,
    examClasses: state.general.examClasses
  };
};

export default reduxForm({
  form: 'search'
})(connect(
  mapStateToProps
)(LessonStatusSearch));



// WEBPACK FOOTER //
// ./src/containers/search/LessonStatusSearch.jsx